export const debounce = (func, delay) => {
	setTimeout(() => {
		func()
	}, delay)
}